export default function MuiFab(theme) {
  return {
    root: {
      color: theme.palette.text.secondary,
    },
  };
}
